/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreProfileGeoPosition
 */
export interface StoreProfileGeoPosition {
    /**
     * 
     * @type {number}
     * @memberof StoreProfileGeoPosition
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof StoreProfileGeoPosition
     */
    lon: number;
}

/**
 * Check if a given object implements the StoreProfileGeoPosition interface.
 */
export function instanceOfStoreProfileGeoPosition(value: object): value is StoreProfileGeoPosition {
    if (!('lat' in value) || value['lat'] === undefined) return false;
    if (!('lon' in value) || value['lon'] === undefined) return false;
    return true;
}

export function StoreProfileGeoPositionFromJSON(json: any): StoreProfileGeoPosition {
    return StoreProfileGeoPositionFromJSONTyped(json, false);
}

export function StoreProfileGeoPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileGeoPosition {
    if (json == null) {
        return json;
    }
    return {
        
        'lat': json['lat'],
        'lon': json['lon'],
    };
}

export function StoreProfileGeoPositionToJSON(json: any): StoreProfileGeoPosition {
    return StoreProfileGeoPositionToJSONTyped(json, false);
}

export function StoreProfileGeoPositionToJSONTyped(value?: StoreProfileGeoPosition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lat': value['lat'],
        'lon': value['lon'],
    };
}

